import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { Platform } from "@src/mobile/utils/platform";

export function useIsRedesignEnabled(): boolean {
  const isEnabled = useCbhFlag(CbhFeatureFlag.ADMIN_APP_NAVIGATION_REDESIGN_ENABLED, {
    defaultValue: false,
  });

  return Platform.isMobile || isEnabled;
}
